import script from "./CollapsibleWidgetSlot.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsibleWidgetSlot.vue?vue&type=script&setup=true&lang=js"

import "./CollapsibleWidgetSlot.vue?vue&type=style&index=0&id=f5574a3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5574a3c"]])

export default __exports__